import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  Baby,
  BookOpen,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CircleHelp,
  CircleX,
  Combine,
  Dna,
  ExternalLink,
  FileText,
  Flag,
  GitCompare,
  Hash,
  History,
  Info,
  LoaderCircle,
  Pill,
  RefreshCw,
  Search,
  Send,
  Stethoscope,
  ThumbsDown,
  ThumbsUp,
  Trash2,
  TriangleAlert,
  X,
  Zap,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react';

// Every icon the app renders, keyed by its kebab-case lucide name.
//
// Deliberately an explicit map rather than `lucide-react/dynamicIconImports`:
// that module is 1542 `() => import(...)` thunks, so Rollup had to emit a
// separate chunk for EVERY icon in the library (1542 of the 1550 files that
// used to land in `dist`) and ship the whole name -> loader table in the entry
// bundle. Each rendered icon then cost its own network round trip behind a
// Suspense placeholder. Static named imports tree-shake to just this list.
//
// To use a new icon, add it here — `IconName` and every call site follow from
// the type, so a typo or a missing entry is a compile error rather than a
// blank space at runtime.
export const ICONS = {
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  baby: Baby,
  'book-open': BookOpen,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-help': CircleHelp,
  'circle-x': CircleX,
  combine: Combine,
  dna: Dna,
  'external-link': ExternalLink,
  'file-text': FileText,
  flag: Flag,
  'git-compare': GitCompare,
  hash: Hash,
  history: History,
  info: Info,
  'loader-circle': LoaderCircle,
  pill: Pill,
  'refresh-cw': RefreshCw,
  search: Search,
  send: Send,
  stethoscope: Stethoscope,
  'thumbs-down': ThumbsDown,
  'thumbs-up': ThumbsUp,
  'trash-2': Trash2,
  'triangle-alert': TriangleAlert,
  x: X,
  zap: Zap,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

interface IconProps extends Omit<LucideProps, 'ref'> {
  name: IconName;
}

const Icon = ({ name, width = 16, height = 16, className, ...props }: IconProps) => {
  const LucideIcon = ICONS[name];

  return <LucideIcon width={width} height={height} className={className} {...props} />;
};

export default Icon;
